import PropTypes from 'prop-types';
import React from 'react';

import { src } from 'utils/imgix';

import styles from './SingleBlock.css';

class SingleBlock extends React.Component {
  renderContent() {
    return this.props.block.content.map((line, i) => (
      <p key={i}>
        {line}
      </p>
    ));
  }

  renderImage() {
    if (this.props.block.imagePath) {
      return (
        <img
          alt={this.props.block.imageAlt}
          className={styles[`image`]}
          src={src(this.props.block.imagePath, 380)}
        />
      );
    }

    return (
      <img
        alt={this.props.block.imageAlt}
        className={styles[`image`]}
        src={`/assets-spa/images/${this.props.block.illustrationPath}`}
      />
    );
  }

  render() {
    return (
      <div className={styles[`container`]}>
        {this.renderImage()}
        <div className={styles[`content`]}>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

SingleBlock.propTypes = {
  block: PropTypes.object.isRequired,
};

export default SingleBlock;
